<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <ng-select
      #select
      class="hb-dropdown hb-multi-select"
      [items]="control.options"
      [virtualScroll]="false"
      [bindLabel]="control.optionLabel"
      [bindValue]="control.optionValue || ''"
      [placeholder]="control.placeholder || control.label"
      [formControlName]="control.key"
      [disabled]="control.disabled"
      [multiple]="true"
      [loading]="control.loading"
      [typeahead]="input$"
      (scrollToEnd)="fetchMore()"
      (close)="onClose()"
      [closeOnSelect]="false"
      [clearSearchOnAdd]="true"
      [ngModel]="
        control.selectedOptionsProperty && control.selectedOptions
          ? control.selectedOptions[control.selectedOptionsProperty]
          : control.selectedOptions
      "
      (ngModelChange)="
        control.selectedOptionsProperty && control.selectedOptions
          ? (control.selectedOptions[control.selectedOptionsProperty] = $event)
          : (control.selectedOptions = $event)
      "
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear" class="text-truncate">
        <div class="ng-value" *ngIf="items.length >= 4; else lessThanFour">
          <span class="ng-value-label" pTooltip="{{ (items | map: control.optionLabel).join(', ') }}" tooltipZIndex="1051"
            >{{ items.length }} items selected</span
          >
        </div>
        <ng-template #lessThanFour>
          <div class="ng-value" *ngFor="let item of items">
            <span class="ng-value-label"> {{ item[control.optionLabel] }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </div>
        </ng-template>
      </ng-template>
    </ng-select>
  </div>
</div>
